<template>
  <div>
    <span>
      {{ address.first_name }} {{ address.last_name }} {{ address.address }}
      {{ address.address2 }} {{ address.state }}, {{ address.state }}
      {{ address.zip }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    address: {
      type: Object,
      required: true,
    },
  },
};
</script>
